<template>
  <div class="history-container" v-if="hasHistories">
    <h2 class="px-3 mx-0 my-0">ประวัติการใช้งาน</h2>
    <div class="activities mx-3 pt-3" v-if="histories.length > 0">
      <div
        class="activity mb-3"
        v-for="(history, index) in histories"
        :key="index"
      >
        <div class="date">{{ history.actionDate | moment-full }}</div>
        <div class="">
          <div>
            <span v-if="isAddRemoveAction(history.action)"
              >{{ history.inviter.firstName }}
              {{ history.inviter.lastName }}</span
            >
            <strong v-else
              >{{ history.inviter.firstName }}
              {{ history.inviter.lastName }}</strong
            >
            <span>{{ historyAction(history.action) }}</span>
          </div>
          <div v-if="isAddRemoveAction(history.action)">
            <strong>{{ history.invitee.firstName }} {{ history.invitee.lastName }}</strong>
            <span v-if="history.action === 'ADD' || history.action === 'ADD_BY_ADMIN'"
            >เป็น {{ activityStatus(history.role) }}</span>
            <span v-if="history.action === 'REMOVE' || history.action === 'REMOVE_BY_ADMIN'"
            >จากการเป็น {{ activityStatus(history.role) }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="activities p-3">
      ไม่มีประวัติการใช้งาน
    </div>
  </div>
</template>

<script>
import { isEmpty } from "ramda";
import { actionActivityHistory, memberActivityStatus } from "@/lib/mapper";

export default {
  props: ["value"],
  computed: {
    histories() {
      return this.value;
    },
    hasHistories() {
      return !isEmpty(this.value);
    }
  },
  methods: {
    isAddRemoveAction(action) {
      return ["ADD", "REMOVE", "ADD_BY_ADMIN", "REMOVE_BY_ADMIN"].indexOf(action) !== -1;
    },
    historyAction(action) {
      return actionActivityHistory[action];
    },
    activityStatus(status) {
      return memberActivityStatus[status];
    }
  }
};
</script>

<style lang="scss" scoped>
.history-container {
  background: white;
  padding: 0;
  h2 {
    padding: 22px 0 23px 0;
    font-size: 16px;
    font-weight: bold;
    color: black;
    border-bottom: 1px solid#e0e0e0;
  }
}
.activities {
  font-size: 14px;
  color: #4a4a4a;
  overflow: auto;
  .date {
    font-size: 11px;
    font-weight: 500;
    color: #8c8786;
    margin-bottom: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/residents/components/ActivityHistory.vue